import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-507fe3df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }
const _hoisted_2 = { class: "pdf-title" }
const _hoisted_3 = { class: "flex justify-between mt-8" }
const _hoisted_4 = { class: "my-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs mr-2" }, "Maluswert", -1))
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom-1" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-2 py-2 font-normal text-gray-500" }, " Bezeichnung "),
  /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-2 py-2 font-normal text-gray-500" }, " Wert ")
], -1))
const _hoisted_9 = {
  style: {"min-width":"80px","max-width":"220px"},
  class: "text-left pl-2 py-2"
}
const _hoisted_10 = {
  style: {"min-width":"80px","max-width":"220px"},
  class: "text-left pl-2 py-2"
}
const _hoisted_11 = { class: "my-2 mr-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom-1" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-2 py-2 font-normal text-gray-500" }, " Bezeichnung "),
  /*#__PURE__*/_createElementVNode("th", { class: "text-left pl-2 py-2 font-normal text-gray-500" }, " Wert ")
], -1))
const _hoisted_13 = {
  style: {"min-width":"80px","max-width":"220px"},
  class: "text-left pl-2 py-2 min-h-fit"
}
const _hoisted_14 = {
  style: {"min-width":"80px","max-width":"220px"},
  class: "text-left pl-2 py-2 min-h-fit"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, "Zusammenfassung"),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, "Zur Erfassung und Klassifizierung von Mängeln werden vorrangig gesetzliche sowie normative Bestimmungen hinsichtlich Sicherheitsanforderungen zugrunde gelegt. Darüberhinausgehend wird der Gesamteindruck des Technikraumes, wie eine ausreichende Beleuchtung oder bauliche Mängel, berücksichtigt.."),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, "Besonderheiten"),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, "Pumpensumpf pumpt in Ausguss im U1."),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, "Mängel"),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, "Teilweise fehlende Brandschutzdurchführung der SML Leitungen durch Decken z.B. Technikzentrale"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, "Fotos"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "",
    alt: ""
  })
], -1))
const _hoisted_16 = { class: "my-16 border-top-1" }
const _hoisted_17 = { class: "mangel-cat my-4 flex flex-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, "Mangelkategorien:")
], -1))
const _hoisted_19 = { class: "flex flex-nowrap items-center mx-1" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Keine Mängel ")
const _hoisted_21 = { class: "flex flex-nowrap items-center mx-1" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Keine relevanten Mängel ")
const _hoisted_23 = { class: "flex flex-nowrap items-center mx-1" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Sicherheitsrelevante Mängel ")
const _hoisted_25 = { class: "flex flex-nowrap items-center" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Versorgungsrelevante Mängel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_acon_logo = _resolveComponent("pdf-acon-logo")!
  const _component_pdf_general_data = _resolveComponent("pdf-general-data")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dummyData.fragenblocks, (fragenblock, key) => {
      return (_openBlock(), _createBlock(_component_pdf_a4_page, {
        key: key,
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pdf_acon_logo),
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("immobilie.pdf.kopfzeile", 1, { locale: _ctx.lang})), 1),
          _createVNode(_component_pdf_general_data, {
            class: "my-4 pb-2 border-bottom-1",
            hzba: _ctx.hzba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["hzba", "immobilie", "lang"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(fragenblock.titel), 1),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createVNode(_component_PdfChip, {
                class: "my-1",
                color: fragenblock.malusColor,
                value: fragenblock.malus,
                "pdf-mode": ""
              }, null, 8, ["color", "value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fragenblock.frages, (entry, key) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: key,
                  class: "data-tr items-center border-bottom-1"
                }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(entry.titel), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(entry.value), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fragenblock.frages, (entry, key) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: key,
                  class: "data-tr items-center border-bottom-1"
                }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(entry.titel), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(entry.value), 1)
                ]))
              }), 128))
            ])
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_PdfChip, {
                  color: "green",
                  "pdf-mode": ""
                }),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_PdfChip, {
                  color: "blue",
                  "pdf-mode": ""
                }),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_PdfChip, {
                  color: "yellow",
                  "pdf-mode": ""
                }),
                _hoisted_24
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_PdfChip, {
                  color: "red",
                  "pdf-mode": ""
                }),
                _hoisted_26
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]))
    }), 128))
  ]))
}